import { useMutation } from "@tanstack/react-query";
import { KeyRound, ShieldCheck } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { PasswordInput } from "../../components/PasswordInput";
import { useAuth } from "../../state/auth";

export function AdminAccountPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const change = useMutation({
    mutationFn: () => api("/admin/account/change-password", {
      method: "POST",
      token: auth.accessToken,
      body: JSON.stringify({ currentPassword, newPassword, confirmPassword })
    }),
    onSuccess: async () => {
      await auth.logout();
      navigate("/admin/login", { replace: true });
    }
  });

  return <div className="mx-auto max-w-2xl">
    <div><p className="text-sm font-extrabold uppercase tracking-widest text-clay-dark">Optional security setting</p><h1 className="mt-2 font-display text-4xl">My account</h1><p className="mt-2 text-ink/55">You may update your password at any time. After a successful change, all refresh sessions will be revoked and you will sign in again.</p></div>
    <form onSubmit={(event) => { event.preventDefault(); change.mutate(); }} className="mt-8 rounded-[2rem] border border-clay/15 bg-white p-6 shadow-pearl sm:p-8">
      <span className="grid size-14 place-items-center rounded-2xl bg-clay/10 text-clay-dark"><KeyRound /></span>
      <div className="mt-6 grid gap-5">
        <PasswordField label="Current password" value={currentPassword} set={setCurrentPassword} autoComplete="current-password" />
        <PasswordField label="New password" value={newPassword} set={setNewPassword} autoComplete="new-password" hint="At least 12 characters with uppercase, lowercase, number, and symbol." />
        <PasswordField label="Confirm new password" value={confirmPassword} set={setConfirmPassword} autoComplete="new-password" />
      </div>
      {change.isError && <div role="alert" className="mt-5 rounded-2xl bg-clay/10 p-4 font-bold text-clay-dark">{change.error.message}</div>}
      <button className="btn-primary mt-6 w-full" disabled={change.isPending || !currentPassword || !newPassword || !confirmPassword}><ShieldCheck size={18} /> {change.isPending ? "Securing account…" : "Change password"}</button>
    </form>
  </div>;
}

function PasswordField({ label, value, set, autoComplete, hint }: { label: string; value: string; set: (value: string) => void; autoComplete: string; hint?: string }) {
  return <label><span className="label">{label}</span><PasswordInput required value={value} onChange={set} autoComplete={autoComplete} />{hint && <span className="mt-1 block text-xs text-ink/45">{hint}</span>}</label>;
}
